(function() {
    const el = document.querySelector('.btn-menu');
    el ? el.addEventListener('click', () => {
            document.querySelector('body').classList.toggle('show');
        }) :
        false;
    $('.overlay a').on('click', function() {
        document.querySelector('body').classList.toggle('show');
    });
})();

function navBar() {
    'use strict';
    let c, currentScrollTop = 0,
        navbar = document.querySelector('header'),
        body = document.querySelector('body');
    let offSetStart = window.pageYOffset;

    window.addEventListener('scroll', () => {
        let a = window.pageYOffset;
        // let b = navbar.offsetHeight;
        let b = 50;
        currentScrollTop = a;
        if (currentScrollTop > 10) {
            navbar.classList.add('top-0');
            $('.nav_hraf_products').addClass('top_185');
        } else {
            navbar.classList.remove('top-0');
            $('.nav_hraf_products').removeClass('top_185');
        }
        if (c < currentScrollTop && a > b + b) {
            if (!body.classList.contains('show')) {
                navbar.classList.add("scrollUp");
            $('.nav_hraf_products').addClass('top_10');
            }
        } else if (c > currentScrollTop && !(a <= b)) {
            navbar.classList.remove("scrollUp");
            $('.nav_hraf_products').removeClass('top_10');
        }
        c = currentScrollTop;
    });
};

$(document).ready(function () {
navBar();

    });